import { useEffect, useRef } from "react";
import { advantages } from "@/mocks/advantages";

export default function AdvantagesSection() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-fade-in-up");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = sectionRef.current?.querySelectorAll(".reveal");
    elements?.forEach((el, i) => {
      (el as HTMLElement).style.animationDelay = `${i * 0.1}s`;
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="advantages"
      ref={sectionRef}
      className="relative py-20 md:py-28 bg-background-50"
    >
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        {/* Section Header */}
        <div className="text-center mb-14 md:mb-20">
          <span className="reveal opacity-0 inline-block px-4 py-1.5 text-xs font-medium tracking-widest uppercase bg-primary-100 text-primary-700 rounded-full mb-4">
            Почему выбирают нас
          </span>
          <h2 className="reveal opacity-0 font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-900 mb-4">
            Наши преимущества
          </h2>
          <p className="reveal opacity-0 text-base md:text-lg text-foreground-600 max-w-2xl mx-auto">
            Шесть причин, по которым гостиничные бизнесы доверяют нам подбор
            своих администраторов
          </p>
        </div>

        {/* Advantages Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {advantages.map((adv) => (
            <div
              key={adv.id}
              className="reveal opacity-0 group p-6 md:p-8 bg-background-50 border border-background-200/70 rounded-lg hover:border-primary-300/60 hover:bg-background-100/50 transition-all duration-300"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-5 group-hover:bg-primary-500 group-hover:text-white transition-colors duration-300">
                <i className={`${adv.icon} text-xl md:text-2xl`} />
              </div>
              <h3 className="font-heading text-xl md:text-2xl text-foreground-900 mb-3">
                {adv.title}
              </h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {adv.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}